import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { urlApi } from '../helpers/functionHelpers';
import { useAlert } from '../context/AlertContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { mostrarAlerta }  = useAlert();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code'); // Obtener el código de autorización

    if (code) {
      // Enviar el código al backend para obtener el JWT
      fetch(`${urlApi}/auth/callback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Error al obtener el token desde el backend');
          }
          return response.json();
        })
        .then((data) => {
          if (data.jwt) {
            // Redirigir al Dashboard con el JWT en la URL
            navigate(`/dashboard?token=${data.jwt}`, { replace: true });
          } else {
            //console.error('No se recibió un JWT válido:', data);
          }
        })
        .catch((error) => mostrarAlerta('Error en la autenticación:', 'error'));
    } else {
      //console.error('No se recibió el código de autorización en la URL');
    }
  }, [navigate, mostrarAlerta]);

  return <h1>Autenticando...</h1>;
};

export default AuthCallback;
